module.exports = __webpack_public_path__ + "img/Stylus Concorde Pro S.8f4b0136.png";